export function getFormattedPrice(priceValue, isoCode='GBP') {

  const langCountry = window.dxp?.settings?.culture?.name || 'en-GB';

  const price = new Intl.NumberFormat(langCountry, {
    style: 'currency',
    currency: isoCode
  });

  return price.format(priceValue);
};
